export default __webpack_public_path__ + "static/media/facebook.b9b33a7d.svg";